// ***************
// src/app/services/cryptoUtils.js
// autor: WdePaula / MVinfo 
// data: 2/7/24 | 19h38
// data: 9/7/24 | 15h18 > mudança do secretkey
// ***************


import CryptoJS from 'crypto-js';

// const secretKey = process.env.REACT_APP_JWT_SECRET;
const secretKey = process.env.REACT_APP_CRIPTKEY;

if (!secretKey) {
    throw new Error('Secret key is not defined in environment variables');
}

export const encrypt = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

// export const decrypt = (encryptedData) => {
//     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//     const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    
//     if (!decryptedData) {
//         throw new Error('Failed to decrypt data');
//     }
//     return JSON.parse(decryptedData);
// };
export const decrypt = (encryptedData) => {
    if (!encryptedData) {
        throw new Error('No encrypted data provided');
    }

    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);

        // Verifica se a descriptografia foi válida
        if (bytes.sigBytes <= 0) {
            throw new Error('Decryption failed: invalid padding or key');
        }

        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

        if (!decryptedData) {
            throw new Error('Decrypted data is empty');
        }

        return JSON.parse(decryptedData);
    } catch (error) {
        console.error('Erro na descriptografia:', error.message);
        throw new Error('Failed to decrypt data');
    }
};
